import { render, staticRenderFns } from "./ArticleCardNews.vue?vue&type=template&id=045210eb"
import script from "./ArticleCardNews.vue?vue&type=script&lang=js"
export * from "./ArticleCardNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports